export function resolveControls(input, context) {
    const requestedSteering = input.turnLeft && !input.turnRight
        ? -1
        : input.turnRight && !input.turnLeft
            ? 1
            : 0;
    const steering = context.driveDirection < 0
        ? requestedSteering === 0
            ? 0
            : requestedSteering === -1
                ? 1
                : -1
        : requestedSteering;
    if (context.driveDirection > 0) {
        return input.brake
            ? { throttle: 0, brake: 1, steering }
            : { throttle: input.accelerate ? 1 : 0, brake: 0, steering };
    }
    if (context.driveDirection < 0) {
        return input.accelerate
            ? { throttle: 0, brake: 1, steering }
            : { throttle: input.brake ? -1 : 0, brake: 0, steering };
    }
    if (input.accelerate && input.brake) {
        return { throttle: 0, brake: 0, steering };
    }
    const stoppedFromDirection = context.stoppedFromDirection ??
        (context.previousInput.brake
            ? 1
            : context.previousInput.accelerate
                ? -1
                : 0);
    const reverseReleaseReady = context.reverseReleaseReady ??
        (stoppedFromDirection !== 1 || !context.previousInput.brake);
    const forwardReleaseReady = context.forwardReleaseReady ??
        (stoppedFromDirection !== -1 || !context.previousInput.accelerate);
    if (input.accelerate) {
        return {
            throttle: stoppedFromDirection !== -1 || forwardReleaseReady ? 1 : 0,
            brake: 0,
            steering,
        };
    }
    if (input.brake) {
        return {
            throttle: stoppedFromDirection !== 1 || reverseReleaseReady ? -1 : 0,
            brake: 0,
            steering,
        };
    }
    return { throttle: 0, brake: 0, steering };
}
